// manifest
import "pwacompat/src/pwacompat";
// add better focus and input type detection on body element
import "what-input";
import "./inputLabel";
import "./jumpArrow";
import "./barba";
import "./customCursor";
import "./errorAudio";
import "./instagram";
import "./postGrid";
import "./teamGrid";
import "./references";
import "./sticky";
import "./swiper";
import "./clipboardText";
import "./vacancies";
import "./openingHours";
import "./video";
import "./blobBackgroundStyle";
import "./arrowLink";
import "./smoothScroll";
import "./components/lottie";
import "./components/header";
import "./blocks/accordion/frontend";

// initial scrollTo
history.scrollRestoration = "manual";
document.addEventListener("DOMContentLoaded", () => {
	const scrollTo = window.location.hash;
	const element = document.getElementById(scrollTo.substring(1));
	if (scrollTo && element) {
		element.scrollIntoView();
	}
});
